import styled from 'styled-components';
import { gridSizes } from 'utils/style';

import AddressSelector from './container';

const LoadingWrapper = styled.div`
  padding: 0 ${gridSizes('M')};
`;

export { LoadingWrapper };
export default styled(AddressSelector)`
  /* width: 450px; */
  width: 100%;

  /* display: flex; */
  /* flex-direction: column; */
  /* align-items: flex-start; */
  padding: 0px;

  /* grey / 100 */

  background: #f2f5f8;
  /* grey / 300 */

  border: 1px solid #ccd6e0;
  border-radius: 4px;

  .address-selector__list {
    /* border: 1px solid red; */
  }

  .loading {
    padding: 12px 0;
    .loadWrap {
      flex-direction: row-reverse;
      .loadText {
        flex: none;
        margin-left: 2rem;
        font-size: 1.6rem;
      }
      .loader {
        margin: 0;
      }
    }
  }

  width: 100%;
`;
